import {createRouter, createWebHistory} from 'vue-router'
import Home from '@/components/Home.vue'

// Naslovna se uvozi odmah jer je ulazna tačka sajta.
// Ostale stranice se učitavaju tek kad se otvore (lazy loading), pa se početno
// učitavanje ne opterećuje kodom stranica koje posjetilac možda nikad ne otvori.
const AboutUs = () => import('@/components/pages/AboutUs.vue')
const Services = () => import('@/components/pages/Services.vue')
const ElektroAgregati = () => import('@/components/pages/ElektroAgregati.vue')
const BoschungSaobracaj = () => import('@/components/pages/BoschungSaobracaj.vue')
const MulagSaobracaj = () => import('@/components/pages/MulagSaobracaj.vue')
const AvioOprema = () => import('@/components/pages/avio-oprema/AvioOprema.vue')
const AvioBoschung = () => import('@/components/pages/avio-oprema/AvioBoschung.vue')
const AvioMulag = () => import('@/components/pages/avio-oprema/AvioMulag.vue')
const AvioFox = () => import('@/components/pages/avio-oprema/AvioFox.vue')
const AvioBertoli = () => import('@/components/pages/avio-oprema/AvioBertoli.vue')
const UpsOvi = () => import('@/components/pages/UpsOvi.vue')
const OsiLiftovi = () => import('@/components/pages/OsiLiftovi.vue')
const Railway = () => import('@/components/pages/Railway.vue')

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/about-us',
        name: 'AboutUs',
        component: AboutUs
    },
    {
        path: '/services',
        name: 'ServicesPage',
        component: Services
    },
    {
        path: '/elektro-agregati',
        name: 'ElektroAgregati',
        component: ElektroAgregati
    },
    {
        path: '/saobracajnica-boschung',
        name: 'BoschungSaobracaj',
        component: BoschungSaobracaj
    },
    {
        path: '/saobracajnica-mulag',
        name: 'MulagSaobracaj',
        component: MulagSaobracaj
    },
    {
        path: '/avio-oprema-aviogei',
        component: AvioOprema,

    },
    {
        path: '/avio-oprema-boschung',
        component: AvioBoschung,

    },
    {
        path: '/avio-oprema-mulag',
        name: 'AvioMulag',
        component: AvioMulag
    },
    {
        path: '/avio-oprema-bliss-fox',
        name: 'AvioFox',
        component: AvioFox
    },
    {
        path: '/avio-oprema-bertoli',
        name: 'AvioBertoli',
        component: AvioBertoli
    },
    {
        path: '/ups-ovi',
        name: 'UpsOvi',
        component: UpsOvi
    },
    {
        path: '/liftovi-za-osi',
        name: 'OsiLiftovi',
        component: OsiLiftovi
    },
    {
        path: '/zeljeznica',
        name: 'RailwayPage',
        component: Railway
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to) {
        if (to.hash) {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({el: to.hash});
                }, 1000);
            });
        } else {
            return {top: 0};
        }
    },
})
export default router
